import * as cc from 'common/constants';
import { CallApi, getBillingApiUrl } from 'common/network';
import { API_V2_URL, API_SP_URL, AUTH_V1_URL } from 'settings/App';

import setSettings from './setSettings';

const fetchSettingsByApp = async (app) => {
  switch (app) {
    case cc.APP.AUTH:
      return CallApi({
        url: `${AUTH_V1_URL}/interface/settings`,
        requestId: cc.FETCH_AUTH_SETTINGS_ID,
      });

    case cc.APP.SOFARM:
      return CallApi({
        url: `${API_V2_URL}/interface/settings`,
        requestId: cc.FETCH_SOFARM_SETTINGS_ID,
      });

    case cc.APP.SFPAGES:
      return CallApi({
        url: `${API_SP_URL}/interface/settings`,
        requestId: cc.FETCH_SFPAGES_SETTINGS_ID,
      });

    case cc.APP.BILLING: {
      const apiUrl = getBillingApiUrl();
      return CallApi({
        url: `${apiUrl}/interface/settings`,
        requestId: cc.FETCH_BILLING_SETTINGS_ID,
      });
    }

    default: {
      console.error(`Fetching settings for application "${app}" is not defined`);
      return { data: null };
    }
  }
};

export const fetchSettings = (app) => async (dispatch) => {
  const { data } = await fetchSettingsByApp(app);

  dispatch(setSettings(app, data));

  return data;
};

export default fetchSettings;



// WEBPACK FOOTER //
// ./src/common/actions/fetchSettings.js